module.exports = __webpack_public_path__ + "img/herramientas_paso2.32949c7d.svg";